import { render, staticRenderFns } from "./ys.vue?vue&type=template&id=5bbbf4de"
import script from "./ys.vue?vue&type=script&lang=js"
export * from "./ys.vue?vue&type=script&lang=js"
import style0 from "./ys.vue?vue&type=style&index=0&id=5bbbf4de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports